import { useLanguage } from 'contexts/LanguageContext';
import countries from 'i18n-iso-countries';
import daLocale from 'i18n-iso-countries/langs/da.json';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { useCallback, useEffect } from 'react';

export const useCountries = () => {
  const userLanguage = useLanguage();

  useEffect(() => {
    // Register locales for supported languages
    countries.registerLocale(daLocale);
    countries.registerLocale(enLocale);
  }, []);

  const getCountryName = useCallback(
    (countryCode: string) => {
      // Get country name based on the current language
      return countries.getName(countryCode, userLanguage.language);
    },
    [userLanguage.language]
  );

  return { getCountryName };
};
